<span *ngIf="(isFontReady$ | async) || notPlaceHolder; else loadingTemplate" [ngClass]="{
        'spin': name === 'progress_activity',
        'filled': filled,
        'outlined': !filled,
        'avatar': avatar,
        'bold': bold,
        'big-avatar': bigAvatar,
        'small-avatar': smallAvatar,
        'avatar-decoration': !!avatarDecoration,
      }"
      [style.color]="color ? color : null"
      [style.background-color]="avatarDecoration ? avatarDecoration : null"
      nz-icon class="material-symbols">{{ name }}</span>

<ng-template #loadingTemplate>
  <nz-skeleton style="display: inline-flex; width: 15px; padding-top: 5px"
               [nzTitle]="false"
               [nzActive]="true"
               [nzParagraph]="{ rows: 1, width: '15px'}"></nz-skeleton>
</ng-template>
